import React, { useRef } from 'react'
import {
  deleteUsers,
  approvedUser,
  rejectUser,
  checkIsUsersHasCase,
} from '@vt/apis/lib-ex/v2/users'
import { Button } from '@ow/comps'
import ChangeGroupModal from './ChangeGroup'
import ConfigRoleModal from './ConfigRole'

// 删除需加二次确认
const BatchOperate = function ({
  appId,
  selectedUsers,
  cancleSeletedUsers,
  usersMutate,
  useUserApi,
  useOrgApi,
}) {
  const { userOperate } = useUserApi || {}
  const { changeOrg, disableUser, activeUser } = userOperate || {}
  const { currentOrg, currentGroup } = useOrgApi
  const popupRef = useRef(null)
  const rolePopupRef = useRef(null)
  const ids = selectedUsers.map((user) => {
    return user.id
  })

  // const [isCanDel, setIsCanDel] = useState(true)
  // const [delTips, setDelTips] = useState(null)
  // const [confirmModalTitle, setConfirmModalTitle] = useState('')
  // const [confirmModalNote, setConfirmModalNote] = useState('')
  // useEffect(() => {
  //   if (delTips) {
  //     setIsCanDel(false)
  //   }
  // }, [delTips])
  // useEffect(() => {
  //   if (isVisibleDisable) {
  //     setConfirmModalTitle('确定要禁用所选用户吗？')
  //   } else {
  //     setConfirmModalTitle(isCanDel ? '确定要删除所选用户吗？' : '')
  //   }

  //   if (isVisibleDisable) {
  //     setConfirmModalNote('禁用后可在‘已禁用’用户列表中恢复启用！')
  //   } else {
  //     setConfirmModalNote(
  //       isCanDel
  //         ? '删除后不可恢复！'
  //         : delTips + '等用户有关联的案件，请单独对此类用户进行删除操作！'
  //     )
  //   }
  // }, [isVisibleDisable, isVisibleDelete])

  const onDeleteUsers = () => {
    // 先判断有没有案件
    checkIsUsersHasCase(ids).then((data) => {
      const hasCaseIds = ids.filter((id) => data[id] === true)
      if (hasCaseIds.length > 0) {
        // 有案件，弹框提示
        const filterUsers = selectedUsers.filter((user) => {
          return hasCaseIds.indexOf(user.id) > -1
        })
        let msg = ''
        filterUsers.forEach((user, index) => {
          const { name, mobile, username } = user
          msg += (index !== 0 ? '、' : '') + (name || username || mobile)
        })
        console.log(msg)
      } else {
        deleteUsers(ids).then(() => {
          usersMutate()
        })
      }
    })
  }

  const onClickPass = () => {
    approvedUser(ids).then(() => {
      usersMutate()
    })
  }

  const onClickRefuse = () => {
    rejectUser(ids).then(() => {
      usersMutate()
    })
  }

  return (
    <>
      <div className="flex flex-row gap-2">
        {(currentGroup === 'all' ||
          currentGroup === 'unActive' ||
          currentOrg) && (
          <Button
            type="primary"
            onClick={() => {
              if (popupRef.current) {
                popupRef.current.open()
              }
            }}
          >
            转移部门
          </Button>
        )}

        {currentOrg && !currentOrg.childrens && (
          <Button
            type="primary"
            onClick={() => {
              if (rolePopupRef.current) {
                rolePopupRef.current.open()
              }
            }}
          >
            配置角色
          </Button>
        )}
        {currentOrg && (
          <Button
            onClick={() => {
              disableUser(ids)
            }}
            type="error"
          >
            禁用
          </Button>
        )}
        {currentGroup === 'disabled' && (
          <Button
            onClick={() => {
              activeUser(ids)
            }}
            type="primary"
          >
            启用
          </Button>
        )}
        {/* {currentGroup === 'disabled' && (
          <Button onClick={onDeleteUsers} type="error">
            删除
          </Button>
        )} */}
        {currentGroup === 'unApproved' && (
          <Button type="primary" onClick={onClickPass}>
            通过
          </Button>
        )}
        {currentGroup === 'unApproved' && (
          <Button title="拒绝" onClick={onClickRefuse} type="error">
            拒绝
          </Button>
        )}
      </div>
      <ChangeGroupModal
        appId={appId}
        userIds={ids}
        changeOrg={changeOrg}
        usersMutate={usersMutate}
        closeModal={() => {
          if (popupRef.current) {
            popupRef.current.close()
          }
          if (cancleSeletedUsers) {
            cancleSeletedUsers()
          }
        }}
        ref={popupRef}
      />
      <ConfigRoleModal
        userIds={ids}
        closeModal={() => {
          if (rolePopupRef.current) {
            rolePopupRef.current.close()
          }
          if (cancleSeletedUsers) {
            cancleSeletedUsers()
          }
        }}
        useUserApi={useUserApi}
        ref={rolePopupRef}
      />
    </>
  )
}

export default BatchOperate
